export const INTEGRATIONS_TYPES = {
	INTEGRATION_INNER_RANGE: {
		id: 1,
		name: 'Integriti',
		defaultCategoryIDs: [20, 21, 22] // INNER_RANGE_DOORS, LIFTS, LIFTS_FLOORS
	},
	INTEGRATION_CONTROL: {
		id: 2,
		name: 'Zezamii Lock',
		// Disjoint from TTLock: Control owns ZEZAMII_ACCESS(17) + ZEZAMII_LOCKERS(19).
		// Mirrors the App Server's canonical SMART_CONTROL_LOCKS (helpers/IntegrationHelper.js
		// + constants/defaultCategories.js) — keep the two in step.
		defaultCategoryIDs: [17, 19] // ZEZAMII_ACCESS, ZEZAMII_LOCKERS
	},
	INTEGRATION_TTLOCK: {
		id: 3,
		name: 'TTLock',
		// Disjoint from Control: TTLock owns SMART_LOCKS(12) + SMART_LOCKER(14).
		// Both previously declared the union of all four ids, so a category-only lookup
		// (.find, insertion order) always resolved to Control and never to TTLock —
		// mis-attributing every TTLock device. The App Server fixed this the same way.
		defaultCategoryIDs: [12, 14] // SMART_LOCKS, SMART_LOCKER
	},
	INTEGRATION_CONTROL_GATEWAY: {
		id: 4,
		name: 'Zezamii Gateway',
		defaultCategoryIDs: [18] // ZEZAMII_GATEWAYS
	},
	INTEGRATION_TTLOCK_GATEWAY: {
		id: 5,
		name: 'TTLock Gateway',
		defaultCategoryIDs: [13] // SMART_GATEWAYS
	},
	// Cloud Key (visitor credential) audit class — matches the App Server
	// helpers/IntegrationHelper.js id 8. No device categories: it tags visitor
	// unlock rows in Log.ExternalAccessLog, it never maps a device to an integration.
	INTEGRATION_CLOUD_KEY: {
		id: 8,
		name: 'Visitor (Cloud Key)',
		defaultCategoryIDs: []
	},
	INTEGRATION_INCEPTION: {
		id: 9,
		name: 'Inception',
		defaultCategoryIDs: [24, 25, 26] // INCEPTION_DOORS, AREAS, LIFT_FLOORS
	}
};

// Camera providers (App Server ids 6/7). Kept apart: they never unlock, so they are not access sources.
export const CAMERA_INTEGRATIONS_TYPES = {
	INTEGRATION_VERKADA: { id: 6, name: 'Verkada' },
	INTEGRATION_VORTEX: { id: 7, name: 'VORTEX' }
};
